import { AirportAutocomplete } from "@airhelp/react-ui-components";
import type { Airport as AirportProps } from "@airhelp/react-ui-components";
import { useCallback, useState, useMemo } from "react";
import type { Dispatch, SetStateAction } from "react";
import debounce from "lodash.debounce";
import { getAirports } from "services/webapp";
import type { AirportOption, AutocompleteInputProps } from "./AutocompleteInput.d";

const updateAirports = debounce((query: string, setAirports: Dispatch<SetStateAction<AirportProps[]>>) => {
  getAirports(query).then((airports) => {
    setAirports(airports);
  });
}, 300);

export const AutocompleteInput = ({
  autoFocus,
  placeholder,
  setAirportSelected,
  dataTestId,
}: AutocompleteInputProps) => {
  const [airports, setAirports] = useState<AirportProps[]>([]);

  const updateDropdownList = useCallback((query: string) => updateAirports(query, setAirports), []);

  const airportOptions = useMemo(() => airports?.map((airport) => ({ value: airport })), [airports]);

  const handleInputChange = (inputValue: string) => {
    if (!inputValue) return setAirports([]);

    return updateDropdownList(inputValue);
  };

  const handleAirportChange = (option: AirportOption) => {
    setAirportSelected(option?.value);
  };

  return (
    <AirportAutocomplete
      options={airportOptions}
      onInputChange={handleInputChange}
      autoFocus={autoFocus}
      placeholder={placeholder}
      handleChange={handleAirportChange}
      dataTestId={dataTestId}
      aria-label={placeholder.toString()}
    />
  );
};
